// src/models/userModel.ts
import {
  brandPsert,
  fetchTenantUsers,
  productsExport,
  serBrandList,
  serBrandRank,
  serbrandProductsStatistics,
  fetchTeamDescription
} from '@/services/AssistantInfo';
import { useRequest } from '@umijs/max';
import { message } from 'antd';
import { SetStateAction, useEffect, useState } from 'react';

interface BrandStatistics {
  productCount: number;
  upProductCount: number;
  downProductCount: number;
}

export default function () {
  const [pathname, setPathname] = useState<string>(''); // 当前页面
  const [pageId, setPageId] = useState<string>(''); // 当前页面id
  const [brandList, setBrandList] = useState([]); // 品牌列表
  const [assistantInfo, setAssistantInfo] = useState<any>({}); // 选中的助手信息
  const [selectedKeys, setSelectedKeys] = useState<any>({}); // 选中的品牌
  const [draggable, setDraggable] = useState<boolean>(false); // 是否可拖拽
  const [tenantUsers, setTenantUsers] = useState([]); // 是否可拖拽
  const [brandStatistics, setBrandStatistics] = useState<BrandStatistics>({
    productCount: 0,
    upProductCount: 0,
    downProductCount: 0,
  }); // 品牌产品统计
  const [teamDescription, setTeamDescription] = useState<any>({}); // 团队描述

  // 获取品牌产品统计
  const { run: getTenantUsers } = useRequest(fetchTenantUsers, {
    manual: true,
    onSuccess: (result: { status: number; payload: any }) => {
      if (result.status === 0) {
        setTenantUsers(result.payload);
      }
    },
  });

  const { run: getTeamDescription } = useRequest(fetchTeamDescription, {
    manual: true,
    onSuccess: (result: { status: number; payload: any }) => {
      if (result.status === 0) {
        setTeamDescription(result.payload);
      }
    },
  });

  // 导出品牌
  const { run: productsExportFn } = useRequest(productsExport, {
    manual: true,
    onSuccess: (response) => { },
  });

  // 获取品牌产品统计
  const { run: getBrandStatistics } = useRequest(serbrandProductsStatistics, {
    manual: true,
    onSuccess: (result: {
      status: number;
      payload: SetStateAction<{ title: string; key: string }[]>;
    }) => {
      if (result.status === 0) {
        setBrandStatistics(result.payload);
      }
    },
  });

  // 获取品牌列表
  const { run: getPsertList } = useRequest(
    (id) => serBrandList({ assistantId: id }),
    {
      manual: true,
      onSuccess: (result: {
        status: number;
        payload: SetStateAction<{ title: string; key: string }[]>;
      }) => {
        if (result.status === 0) {
          setBrandList(result.payload || []);
          console.log(result.payload, 'result.payload');
          setSelectedKeys(result?.payload[0]?.id);
          getBrandStatistics(result?.payload[0]?.id);
          
          // if (selectedKeys?.id) {
          //   setSelectedKeys((pre) => {
          //     const resData = result.payload?.find((j) => j.id === pre.id);
          //     getBrandStatistics(pre?.id);
          //     return { ...pre, ...resData };
          //   });
          // }
        }
      },
    },
  );

  useEffect(() => {
    if (pageId && assistantInfo?.id && assistantInfo?.userRole !== 3) {
      getPsertList(pageId);
      setSelectedKeys({});
    }
  }, [pageId]);

  useEffect(() => {
    if (selectedKeys?.id) getBrandStatistics(selectedKeys?.id);
  }, [selectedKeys?.id]);

  // 添加品牌
  const { loading: handleAddPsertIng, run: handleAddPsert } = useRequest(
    brandPsert,
    {
      manual: true,
      onSuccess: (result) => {
        if (result.status === 0) {
          getPsertList(pageId);
          message.success(result.payload || '品牌添加成功');
        }
      },
    },
  );
  // 排序品牌
  const { loading: handleBrandRankIng, run: handleBrandRank } = useRequest(
    serBrandRank,
    {
      manual: true,
      onSuccess: (result, params) => {
        if (result.status === 0) {
          getPsertList(pageId);
          message.success(result.payload || '品牌排序成功');
        }
      },
    },
  );

  return {
    brandList,
    setBrandList,
    getPsertList,
    handleAddPsert,
    handleBrandRank,
    pathname,
    setPathname,
    pageId,
    setPageId,
    draggable,
    setDraggable,
    selectedKeys,
    setSelectedKeys,
    brandStatistics,
    getBrandStatistics,
    assistantInfo,
    setAssistantInfo,
    tenantUsers,
    productsExportFn,
    teamDescription,
    getTenantUsers,
    getTeamDescription
  };
}
